import type { Migration, MigrationState } from "../api/types";
import { formatPauseAt } from "../api/types";
import { Badge } from "../components";
import { t, tDynamic } from "../i18n/t";
import { statePillTone } from "./stageRoute";

type Pause = Migration["pause"];

/**
 * ONE presentation of "where is this migration", shared by the list row, the migration header and the
 * status page. A migration waiting on a vendor's daily API limit keeps its working state (`extracting`) on
 * the server, so showing only the state says "Extracting" while nothing is happening; the `pause` view the
 * API already derives (the same one the CLI status line and the top banner use) says what is true.
 */
export function MigrationStateBadge({ state, pause }: { state: MigrationState; pause?: Pause }): JSX.Element {
  if (pause !== null && pause !== undefined) {
    return (
      <Badge tone="warn" dot>
        {t("migration.badge_paused")}
      </Badge>
    );
  }
  return (
    <Badge tone={statePillTone(state)} dot>
      {tDynamic("state.", state)}
    </Badge>
  );
}

/** "resumes after Oct 21 17:53" (local time), or "was due to resume at ..." once that time has passed. */
export function pauseResumeText(pause: NonNullable<Pause>): string {
  const at = formatPauseAt(pause.until);
  return new Date(pause.until).getTime() > Date.now()
    ? t("migration.resumes_after", { at })
    : t("migration.resume_overdue", { at });
}
